module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00301.625c6120.jpg";